export default {"src":"/_next/static/media/polygon-color.12f321b0.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};